import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";

export default function Lists({ helpfulLinks, shopLinks }) {
  const theme = useTheme();

  const helpfulLinksItems = helpfulLinks?.map((e, index) => (
    <ListItem key={index} disablePadding>
      <ListItemButton
        component={Link}
        to={e?.route}
        sx={{
          textAlign: "center",
          transition: "all .3s",
          ":hover": {
            bgcolor: "rgba(0,0,0,.4)",
            color: `${theme.palette.primary.main} !important`,
          },
          borderRadius: "8px",
        }}
      >
        <ListItemText
          primary={e?.title}
          primaryTypographyProps={
            {
              // color: theme.palette.text.primary,
              // ":hover": { bgcolor: "rgba(0,0,0,.4)", color: "gold !important" },
            }
          }
        />
      </ListItemButton>
    </ListItem>
  ));

  const shopLinksItems = shopLinks?.map((e, index) => (
    <ListItem key={index} disablePadding>
      <ListItemButton component={Link} sx={{ textAlign: "center" }}>
        <ListItemText
          primary={e?.title}
          primaryTypographyProps={{
            color: theme.palette.text.primary,
          }}
        />
      </ListItemButton>
    </ListItem>
  ));

  return (
    <>
      {/* Helpful Links */}
      <List sx={{ textAlign: "center" }}>
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontWeight: 500,
            mb: "1rem",
            fontSize: "1.1rem",
          }}
        >
          لینک های مفید
        </Typography>
        {helpfulLinksItems}
        <a
          href="https://trustseal.enamad.ir/?id=463833&Code=l1Ry3KEMPMwmFbSTtP9kkdnYPNu0eXxr"
          referrerPolicy="origin"
          target="_blank"
          rel="noopener"
        >
          <img
            style={{ width: "80px", marginTop: "20px" }}
            src="/Media/e-namad.webp"
            alt="enamad"
          />
        </a>
      </List>

      {/* Shop Links */}
      {/* <List sx={{ textAlign: "center" }}>
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontWeight: 500,
            mb: "1rem",
            fontSize: "1.1rem",
          }}
        >
          فروشگاه
        </Typography>

        {shopLinksItems}
      </List> */}
    </>
  );
}
